import { render, staticRenderFns } from "./TextBlock.vue?vue&type=template&id=2e446915&scoped=true"
import script from "./TextBlock.vue?vue&type=script&lang=js"
export * from "./TextBlock.vue?vue&type=script&lang=js"
import style0 from "./TextBlock.vue?vue&type=style&index=0&id=2e446915&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e446915",
  null
  
)

export default component.exports